export const environment = {
  production: true,
  //apiUrl: 'https://192.168.1.13:7106/api'
  apiUrl: 'https://be-test-bms.app.ubiecloud.com/api'
};
